import React from "react";

import AddIcon from "@Shared/icons/AddIcon";
import { AddButtonContainer } from "./styles";

const AddButton = ({
  onClick = () => {},
  customStyles = { minHeight: "auto" },
  hasCards = false,
}) => {
  return (
    <AddButtonContainer
      onClick={onClick}
      style={hasCards ? customStyles : { minHeight: "256px" }}
    >
      <AddIcon />
    </AddButtonContainer>
  );
};

export default AddButton;
